import { useMemo } from 'react'
import { useSelector } from 'hooks'
import { DictionariesContext } from 'core/contexts'

const DictionariesLayer: React.FC = ({ children }) => {
  const dictionaries = useSelector(
    ({ dictionaries }) => dictionaries.dictionariesData.result?.dictionaries
  )

  const dictionariesContextValue = useMemo(() => ({ dictionaries }), [dictionaries])

  return (
    <DictionariesContext.Provider value={dictionariesContextValue}>
      {children}
    </DictionariesContext.Provider>
  )
}

export default DictionariesLayer
